import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  date: {
    id: 'alSubForm.date',
    defaultMessage: 'Päivämäärä',
  },
  vehicleMileage: {
    id: 'alSubForm.vehicleMileage',
    defaultMessage: 'Mittarilukema, km',
  },
  caseNumber: {
    id: 'alSubForm.caseNumber',
    defaultMessage: 'Tilauksen viite',
  },
  billingInfo: {
    id: 'alSubForm.billingInfo',
    defaultMessage: 'Laskutus',
  },
  personCount: {
    id: 'alSubForm.personCount',
    defaultMessage: 'Henkilömäärä',
  },
  serviceChannel: {
    id: 'alSubForm.serviceChannel',
    defaultMessage: 'Palvelukanava',
  },
  serviceType: {
    id: 'alSubForm.serviceType',
    defaultMessage: 'Työn tyyppi',
  },
  additionalInfo: {
    id: 'alSubForm.additionalInfo',
    defaultMessage: 'Työselvitys Autoliitolle',
  },
  notes: {
    id: 'alSubForm.notes',
    defaultMessage: 'Muistiinpanot (sisäiseen käyttöön)',
  },
  invalidArcComponentForServiceType: {
    id: 'alSubForm.invalidArcComponentForServiceType',
    defaultMessage: 'Virheellinen ARC-komponentti ({componentType}) valitulle toimenpiteelle, valitse jokin toinen soveltuva komponentti.',
  },
  invalidArcDescriptionCodeNotDiagnosable: {
    id: 'alSubForm.invalidArcDescriptionCodeNotDiagnosable',
    defaultMessage: 'Virheellinen ARC-vikakoodi (46, Ei diagnosoitavissa), valitse jokin toinen soveltuva vikakoodi.',
  },
  invalidArcDescription: {
    id: 'alSubForm.invalidArcDescription',
    defaultMessage: 'Virheellinen ARC-vikakoodi ({descriptionType}), valitse jokin toinen soveltuva vikakoodi.',
  },
})
